import { apiClient } from "@/services/apiClient";

export type PlatformRole = "root" | "root_admin";

export interface PlatformUser {
  id: string;
  email: string;
  displayName: string | null;
  platformRole: PlatformRole;
  status: string;
  createdAt: string;
}

export interface ListPlatformUsersParams {
  page: number;
  limit: number;
}

export interface ListPlatformUsersResult {
  data: PlatformUser[];
  total: number;
  page: number;
  limit: number;
}

export interface PendingRootInvite {
  id: string;
  email: string;
  platformRole: PlatformRole;
  invitedByUserId: string;
  invitedByEmail: string | null;
  expiresAt: string;
  createdAt: string;
  expired: boolean;
}

export function listPlatformUsers(
  params: ListPlatformUsersParams
): Promise<ListPlatformUsersResult> {
  return apiClient
    .get<ListPlatformUsersResult>("/platform/users", {
      params: { page: params.page, limit: params.limit },
    })
    .then((res) => res.data);
}

export function listPendingRootInvites(): Promise<PendingRootInvite[]> {
  return apiClient
    .get<PendingRootInvite[]>("/platform/root-invites")
    .then((res) => res.data);
}

export function inviteRootUser(payload: {
  email: string;
  platformRole: PlatformRole;
}): Promise<void> {
  return apiClient
    .post("/auth/root-invite", {
      email: payload.email.trim().toLowerCase(),
      platformRole: payload.platformRole,
    })
    .then(() => undefined);
}

export function resendRootInvite(id: string): Promise<void> {
  return apiClient
    .post(`/platform/root-invites/${id}/resend`)
    .then(() => undefined);
}

export function cancelRootInvite(id: string): Promise<void> {
  return apiClient
    .delete(`/platform/root-invites/${id}`)
    .then(() => undefined);
}
